export default {
    added_to: 'Added to',
    add_a_book: 'Add a book',
    buy_a_book: 'Buy a book',
    choose_a_book_from_the_library: 'Choose a book from the library.',
    collect_beecoins: 'Collect BeeCoins and go to the store for your favorite book.',
    delete_to: 'Delete to',
    error_consulting_books: 'There was an error consulting books.',
    my_list: 'My list',
    no_books_found: 'Whoops! You don\'t have books here yet. Go find your next library adventure!',
    search_result: 'Results for',
    title_carousel_1: 'My list',
    title_carousel_2: 'The top 10 most requested books',
    subtitle_carousel_2: 'The 10 books most read by our readers',
    title_carousel_3: 'The top 10 most valued books',
    title_carousel_4: 'Novelties',
    subtitle_carousel_4: 'Discover the latest books added',
    title_carousel_5: 'My magazines',
    title_carousel_6: 'Suggestions for you',
    title_carousel_7: 'Continue reading',
    title_button_card: 'Read',
    not_books_data: 'No books to show',
    book_tittle_required: 'The title of the book is required',
    more: 'More',
    in: 'in'
}
